/**
 * @generated SignedSource<<1cb9e78ebbe7bd74d48ceb6d50a9f8ba>>
 * @relayHash c8dae027e4bc9fed584f45ac306dfd24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a1e6f12b975747e28f996e1ada328a35418a9cbd765373a762a14fcbf401495

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AppConfigurationPromptQuery } from './AppConfigurationPromptQuery.graphql';

const node: PreloadableConcreteRequest<AppConfigurationPromptQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8a1e6f12b975747e28f996e1ada328a35418a9cbd765373a762a14fcbf401495",
    "metadata": {},
    "name": "AppConfigurationPromptQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
